export type GetIfConversionRulesRequest = {
  envrnmntIdFrom: string;
  envrnmntIdTo: string;
  dfnSetVerNum: string;
};
